<template>
    <v-app id="app">
        <nav-bar></nav-bar>
        <v-main>
            <v-fade-transition mode="out-in">
                <router-view />
            </v-fade-transition>
        </v-main>
    </v-app>
</template>

<script>
    import NavBar from '@/components/base/NavBar';

    export default {
        name: 'App',
        components: {
            NavBar
        }
    };
</script>

<style>

</style>
